(() => {
  if (!customElements.get('beacon-artwork-submission')) {
    customElements.define('beacon-artwork-submission', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          if (this.dataset.managedUpload === 'true') {
            this.controller = new AbortController();
            const {signal} = this.controller;
            const now = this.querySelector('[data-artwork-mode][value="now"]');
            const later = this.querySelector('[data-artwork-mode][value="later"]');
            if (later) later.disabled = true;
            for (const name of ['input', 'change']) this.addEventListener(name, event => {
              if (!event.target.matches('[data-artwork-mode]')) return;
              event.stopPropagation();
              if (now) now.checked = true;
              if (later) later.checked = false;
            }, {signal});
            return;
          }
          const inputs = this.querySelectorAll('[data-artwork-upload] input[type="file"]');
          if (inputs.length !== 1) return;
          this.fileInput = inputs[0];
          this.upload = this.querySelector('[data-artwork-upload]');
          this.statusInput = this.querySelector('[data-artwork-status]');
          this.note = this.querySelector('[data-artwork-later]');
          this.modes = [...this.querySelectorAll('[data-artwork-mode]')];
          this.laterInput = this.modes.find(input => input.value === 'later');
          if (!this.statusInput || !this.note || !this.laterInput) return;
          this.controller = new AbortController();
          const {signal} = this.controller;
          this.wasDisabled = this.fileInput.disabled;
          this.originalName = this.fileInput.getAttribute('name');
          this.originalRequired = this.fileInput.required;
          this.fileInput.name = 'properties[_artwork_file]';
          this.laterInput.disabled = this.dataset.sendLaterReady !== 'true';
          this.addEventListener('input', event => {
            if (event.target.matches('[data-artwork-mode]')) event.stopPropagation();
          }, {signal});
          this.addEventListener('change', event => {
            if (!event.target.matches('[data-artwork-mode]')) return;
            event.stopPropagation();
            this.sync(true);
          }, {signal});
          this.form = this.fileInput.form;
          this.form?.addEventListener('reset', () => queueMicrotask(() => {
            if (this.isConnected) this.sync(true);
          }), {signal});
          this.sync(false);
        });
      }

      get artworkState() {
        const pending = this.statusInput && !this.statusInput.disabled;
        return {
          mode: pending ? 'later' : 'now',
          status: pending ? 'pending_post_checkout' : 'upload_now',
          file: pending ? null : this.fileInput?.files?.[0] || null,
          properties: pending ? {_artwork_status: 'pending_post_checkout'} : {}
        };
      }

      sync(notify) {
        const pending = this.dataset.sendLaterReady === 'true' && this.laterInput.checked;
        this.modes.forEach(input => {
          input.checked = input.value === (pending ? 'later' : 'now');
        });
        this.upload.hidden = pending;
        this.fileInput.required = !pending;
        this.fileInput.disabled = pending || this.wasDisabled;
        this.statusInput.disabled = !pending;
        this.statusInput.value = 'pending_post_checkout';
        this.note.hidden = !pending;
        if (notify) this.dispatchEvent(new CustomEvent('beacon:artwork-intent', {
          bubbles: true,
          detail: this.artworkState
        }));
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        if (this.fileInput) {
          this.fileInput.disabled = this.wasDisabled;
          this.fileInput.required = this.originalRequired;
          if (this.originalName === null) this.fileInput.removeAttribute('name');
          else this.fileInput.name = this.originalName;
        }
      }
    });
  }

  if (!customElements.get('beacon-paper-guide')) {
    customElements.define('beacon-paper-guide', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          const open = document.getElementById(this.dataset.openId);
          const close = this.querySelector('[data-paper-guide-close]');
          const dialog = this.querySelector('dialog');
          if (!open || !close || !dialog || typeof dialog.showModal !== 'function') return;
          this.controller = new AbortController();
          this.dialog = dialog;
          this.opener = open;
          const {signal} = this.controller;
          open.disabled = false;
          open.addEventListener('click', () => {
            if (!dialog.open) dialog.showModal();
            open.setAttribute('aria-expanded', 'true');
          }, {signal});
          close.addEventListener('click', () => dialog.close(), {signal});
          dialog.addEventListener('close', () => {
            open.setAttribute('aria-expanded', 'false');
            if (open.isConnected) open.focus({preventScroll: true});
          }, {signal});
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const box = dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
          }, {signal});
        });
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.controller = null;
        if (this.opener) this.opener.disabled = true;
      }
    });
  }
})();
